import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getMessaging } from "firebase/messaging";

// Initialize Firebase
const app = initializeApp(
  {
    apiKey: "AIzaSyCFhzEnsofWlvRhZTgW5Uw5pJcc-X-oZxk",
    authDomain: "onmove-f0ba4.firebaseapp.com",
    projectId: "onmove-f0ba4",
    databaseURL: "https://onmove-f0ba4-default-rtdb.firebaseio.com",
    storageBucket: "onmove-f0ba4.firebasestorage.app",
    messagingSenderId: "935682555766",
    appId: "1:935682555766:web:71aeea1d93dee852a78457",
    measurementId: "G-7K7SVM57VN"
  }
)
export const auth = getAuth(app)
export const db = getFirestore(app)
export const storage = getStorage(app)
export const messaging = getMessaging(app);



// firebase login
// firebase init
// firebase deploy --only hosting:onmove-admin

